import React from 'react';
import { Outlet } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Sidebar from './Sidebar';
import MobileHeader from './MobileHeader';
import { useSidebarState } from '../../hooks/useSidebarState';
import { CollaborationStatus } from '../../components';
import './Sidebar.css';

/**
 * Layout principal de l'application
 * Contient la sidebar, le header mobile et le contenu principal
 */
const MainLayout = ({ user, token, onLogout }) => {
  const {
    isCollapsed,
    isMobileOpen,
    isMobile,
    toggleSidebar,
    openMobileMenu,
    closeMobileMenu
  } = useSidebarState();

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        className="app-layout"
        data-sidebar-collapsed={isCollapsed}
      >
        {/* Header mobile (visible uniquement sur mobile) */}
        <MobileHeader onMenuOpen={openMobileMenu} />

        {/* Sidebar */}
        <Sidebar
          user={user}
          isCollapsed={isCollapsed}
          isMobileOpen={isMobileOpen}
          onToggle={toggleSidebar}
          onLogout={onLogout}
          onCloseMobile={closeMobileMenu}
        />

        {/* Overlay mobile */}
        <div
          className={`sidebar-overlay ${isMobileOpen ? 'visible' : ''}`}
          onClick={closeMobileMenu}
          aria-hidden="true"
        />

        {/* Contenu principal */}
        <main className="main-content">
          <div className="main-content-inner">
            <Outlet />
          </div>
          <AppFooter />
        </main>

        {/* Indicateur de collaboration */}
        <CollaborationStatus />
      </div>
    </DndProvider>
  );
};

/**
 * Footer de l'application
 */
const AppFooter = () => {
  // Import dynamique de la version
  let version = '1.0.0';
  try {
    const packageInfo = require('../../../package.json');
    version = packageInfo.version;
  } catch (e) {
    // Fallback si le package.json n'est pas accessible
  }

  return (
    <footer style={{
      textAlign: 'center',
      padding: '12px 20px',
      fontSize: '12px',
      color: '#999',
      borderTop: '1px solid #eee',
      background: '#f8f9fa',
      marginTop: 'auto'
    }}>
      <span>© {new Date().getFullYear()} 6B Digital - Renfort Connect</span>
      <span style={{ margin: '0 8px' }}>|</span>
      <span>v{version}</span>
    </footer>
  );
};

export default MainLayout;
